module.exports = ".orbit-editor {\n  font-size: 3rem;\n  line-height: 100%; }\n\n.orbit-editor-calendar {\n  font-size: 2.5rem; }\n\np {\n  font-size: 1.1rem; }\n\n.hoverable-o {\n  opacity: 1; }\n\n.hoverable-o:hover {\n  opacity: 0.8; }\n\n.header-row {\n  height: 25%; }\n\n.body-row {\n  height: 75%; }\n\n.checkbox {\n  display: inline-block;\n  width: 3rem;\n  height: 3rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/timing/timing.component.scss
// module id = ./src/app/components/timing/timing.component.scss
// module chunks = main